<div class="header-banner" [ngClass]="type">
  <app-info-banner class="info" [banner]="banner" [loading]="loading" [type]="type" [style]="style"></app-info-banner>
  <picture *ngIf="!loading">
    <source srcset="{{ banner?.image.url }}" media="(min-width: 576px)">
    <source srcset="{{ banner?.image_mobile.url }}" media="(max-width: 575px)">
    <img class="banner-img" src="{{ banner?.image.url }}" alt="{{ banner?.image.alt }}" title="{{banner?.image.title}}">
  </picture>
</div>
